import { jsonGet } from "../api";

export const fetchLLmProviders = async () => jsonGet("llm-providers");
